<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'gem']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption" v-if="!isPrintEmpty">結婚歴</v-list-tile-sub-title>
      <v-list-tile-title>{{ printMarry }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-tooltip bottom>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading" @click="edit"><font-awesome-icon :icon="['fal', 'pencil']"/></v-btn>
        <span>編集する</span>
      </v-tooltip>
    </v-list-tile-action>
  </v-list-tile>
  <v-container v-else>
    <v-subheader>結婚歴</v-subheader>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-radio-group required row
          v-model="form.marry.content"
          :rules="rules.marry">
          <v-radio v-for="(item, key) in getMarryItems" :key="key"
            color="blue darken-2"
            :label="item" :value="key"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicMarry',
  components: {
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      meta: {
        marry: {
          '未婚': '未婚',
          '既婚': '既婚'
        }
      },
      form: {
        marry: {
          id: '',
          content: ''
        }
      },
      rules: {
        marry: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.marry
      ) {
        this.$set(this.form, 'marry', {
          id: '' + (this.$props.data.marry.id ? this.$props.data.marry.id : 'new_marry'),
          content: this.$props.data.marry.content ? this.$props.data.marry.content : ''
        })
      } else {
        this.$set(this.form, 'marry', {
          id: 'new_marry',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'marry'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['marry', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'marry'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['marry', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'marry'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props &&
        this.$props.data &&
        this.$props.data.marry &&
        this.$props.data.marry.content
      )
    },
    getMarryItems () {
      return this.meta.marry
    },
    printMarry () {
      return (
        this.$props &&
        this.$props.data &&
        this.$props.data.marry &&
        this.$props.data.marry.content
      ) ? this.$props.data.marry.content : '結婚歴'
    }
  }
}
</script>
